<template>
    <div class="project-sort" @click="$emit('cancel')">
        <div class="sort-content" @click.stop>
            <div class="sort-item" :class="[{'active': (type2 != '' && sortType == item.key)  || (type2 == '' && sortType.includes(item.key))}]" @click="setSort(item)" v-for="(item, index) in sortData" :key="index">
                <template v-if="type2 == ''">
                    <span>{{item.name}}</span>
                    <div v-show="sortType.includes(item.key)" class="tick2"><img src="@/assets/img/tick2.png" /></div>
                </template>
                <template v-else>
                    <div v-show="sortType == item.key" class="tick"><img src="@/assets/img/tick2.png" /></div>
                    <span>{{item.name}}</span>
                </template>
            </div>
            <div class="buttons" v-if="type2 == ''">
                <sd-button plain mini2 class="reset" @click.native="reset()">{{$t('text.reset')}}</sd-button>
                <sd-button mini2 @click.native="confirm()">{{$t('text.confirm')}}</sd-button>
            </div>
        </div>
    </div>
</template>

<script>
import sdButton from "./button";

export default {
    name: "sd-sort",

    components: { sdButton },

    props: {
        value: {
            type: [String, Number, Array]
        },
        list: Array,
        type2: String
    },

    data() {
        return {
            sortType: this.value
        }
    },

    computed: {
        sortData() {
            return this.list;
        }
    },

    watch: {
        value(val) {
            this.sortType = val;
        },
        sortType(val) {
            this.$emit('update:value', val)
        }
    },

    methods: {
        setSort(item) {
            if(this.type2 == '') {
                let newTypes = this.sortType.filter(sort => {
                    return sort != item.key
                })
                if(newTypes.length == this.sortType.length) {
                    this.sortType.push(item.key)
                }else {
                    this.sortType = newTypes;
                }
            }else {
                this.$emit("choose", item)
            }
        },

        reset() {
            this.sortType = []
        },

        confirm() {
            this.$emit("confirm", this.sortType)
        }
    }
}
</script>

<style lang="scss" scoped>
.project-sort {
    background: rgba(0, 0, 0, 0.4);
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;

    .sort-item {
        height: 16px;
        line-height: 16px;
        color: #787D85;
        font-size: 14px;
        background: white;
        text-align: left;
        padding-top: 16px;
        padding-left: 16px;
        position: relative;
        display: flex;

        .tick {
            width: 20px;
            margin-right: 4px;
        }

        .tick2 {
            width: 20px;
            margin-left: auto;
            margin-right: 16px;
        }

        &.active {
            color: #E22F25;

            span {
                // padding-left: 24px;
            }
        }

        &:last-child {
            padding-bottom: 16px;
        }
    }

    .buttons {
        display: flex;
        background-color: white;
        padding: 28px 16px 12px;

        .reset {
            width: 106px;
            margin-right: 10px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/sort.vue